const phoneNumber = {
  validator: (_, value, callback) => {
    if (!(/^1\d{10}$/.test(value))) {
      callback(new Error('请填写正确的手机号码'))
    } else {
      callback()
    }
  },
  trigger: ['blur', 'change']
}

const requiredRuleFactory = (message, trigger = ['blur', 'change']) => [{ message, trigger, required: true }]
const lengthRuleFactory = (len, message, trigger = ['blur', 'change']) => [{ message, min: len, trigger }]

async function promisedValidate(form) {
  return new Promise((resovle, reject) => {
    form.validate(valid => {
      valid ? resovle() : reject('form validate failed')
    })
  })
}

const formHelper = {
  promisedValidate,
  requiredRuleFactory,
  lengthRuleFactory,
  rules: {
    emailRequired: [...requiredRuleFactory('请输入您的企业邮箱'), { type: 'email', message: '请输入正确的企业邮箱', trigger: ['blur', 'change'] }],
    passwordRequired: [...requiredRuleFactory('请填写密码'), ...lengthRuleFactory(6, '请输入至少6位数的密码')],
    phoneNumber: [phoneNumber],
    phoneNumberRequired: [...requiredRuleFactory('请填写手机号码'), phoneNumber],
    dynamicCodeRequired: [...requiredRuleFactory('请填写验证码')]
  }
}

export default {

  install(Vue) {
    Vue.prototype.$formHelper = formHelper
  }

}
